/**
 * VALEN VARET · Apertura y cierre de la guía de tallas.
 *
 * Delegación de eventos en el documento: funciona aunque el tema vuelva a
 * pintar la ficha de producto al cambiar de variante (Horizon reemplaza el
 * HTML de la sección, así que no sirve enganchar listeners a los botones).
 */

const SELECTOR_OPEN = '[data-vv-sizeguide-open]';
const SELECTOR_CLOSE = '[data-vv-sizeguide-close]';

function findDialog(trigger) {
  const id = trigger.getAttribute('data-vv-sizeguide-open');
  if (id) {
    const byId = document.getElementById(id);
    if (byId) return byId;
  }
  // Respaldo: la guía más cercana dentro de la misma ficha.
  const scope = trigger.closest('.variant-picker, .product-details, body');
  return scope ? scope.querySelector('dialog[data-vv-sizeguide]') : null;
}

document.addEventListener('click', (event) => {
  const opener = event.target.closest?.(SELECTOR_OPEN);
  if (opener) {
    const dialog = findDialog(opener);
    if (dialog && typeof dialog.showModal === 'function') {
      event.preventDefault();
      if (!dialog.open) dialog.showModal();
    }
    return;
  }

  const closer = event.target.closest?.(SELECTOR_CLOSE);
  if (closer) {
    const dialog = closer.closest('dialog[data-vv-sizeguide]');
    if (dialog?.open) {
      event.preventDefault();
      dialog.close();
    }
  }
});

// Cerrar al pulsar fuera de la tarjeta (el backdrop es el propio <dialog>).
document.addEventListener('mousedown', (event) => {
  const dialog = event.target.closest?.('dialog[data-vv-sizeguide]');
  if (!dialog || !dialog.open) return;
  if (!event.target.closest('.vv-dialog__inner')) dialog.close();
});